import { APP_COLOR } from "constant";
import styled from "styled-components";

type P_Props = {
  children?: any;
};

export const PopoverMenu = styled.div`
  min-width: 200px;
  background-color: white;
  border-radius: 4px;
  & > * {
    cursor: pointer;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    font-size: 16px;
    border-radius: 4px;
    color: ${APP_COLOR.PRIMARY};
    letter-spacing: 0.7px;
    &:hover,
    &.active {
      background-color: #f3f5f9;
      font-weight: bold;
      letter-spacing: 0;
    }
    span {
      line-height: 100%;
    }
  }
`;

const PopoverMenuPresenter = (props: P_Props) => {
  return <PopoverMenu>{props.children}</PopoverMenu>;
};

export default PopoverMenuPresenter;
